<template>
    <div class="dropdown-container">
        <div class="dropdown-selected" @click="toggleDropdown">
            <span v-if="selectedStaff">
                {{ selectedStaff.First_Name }} {{ selectedStaff.Last_Name }} - {{ getEnrollerStatus(selectedStaff) }}
            </span>
            <span v-else>
                {{ notListed ? "Other/I'm Not Listed" : 'Select a staff...' }}
            </span>
            <span class="dropdown-arrow" :class="{ open: showDropdown }">&#9662;</span>
        </div>
        <div v-if="showDropdown" class="dropdown-options">
            <div class="dropdown-option search">
                <input class="w-full" name="staff" type="text" v-model="staffSearch" @keyup="filterStaff(staffSearch)"/>
            </div>
            <div class="dropdown-option placeholder">
                <span class="name">&lt;Staff Name&gt;</span>
                <span class="status">&lt;Enroller Status&gt;</span>
            </div>
            <div v-for="staff in sortedStaff" :value="staff" :key="staff.External_GUID" class="dropdown-option"
                @click="selectStaff(staff)">
                <span class="name">{{ staff.First_Name }} {{ staff.Last_Name }}</span>
                <span class="status">{{ getEnrollerStatus(staff) }}</span>
            </div>
            <div class="dropdown-option" @click="selectStaff(null, true)">Other/I'm Not Listed</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StaffSelectionDropdown',
    data() {
        return {
            showDropdown: false,
            selectedStaff: null,
            notListed: false,
            staffSearch: ''
        };
    },
    props: {
        staffList: [],
        filteredStaffList: []
    },
    computed: {
        //sort staff alphabetically
        sortedStaff() {
            return this.filteredStaffList.slice().sort((a, b) => {
                return a.First_Name.localeCompare(b.First_Name);
            });
        },
    },
    methods: {
        toggleDropdown() {
            this.showDropdown = !this.showDropdown;
        },
        selectStaff(staff, notListed = false) {
            if (notListed) {
                this.selectedStaff = "";
                this.notListed = true;
            } else {
                this.notListed = false;
                this.selectedStaff = staff;
            }
            this.$emit('selectedStaff', this.selectedStaff);
            this.showDropdown = false;
        },
        getEnrollerStatus(staff) {
            if (staff.ClinicianSetting && staff.ClinicianSetting.EnrollerStatus && staff.ClinicianSetting.EnrollerStatus.Name && staff.ClinicianSetting.EnrollerStatus.Name != 'Untrained') {
                return staff.ClinicianSetting.EnrollerStatus.Name;
            } else {
                return "";
            }
        }
        ,
        filterStaff(staff){
            if(staff != ""){
                this.filteredStaffList = this.staffList.slice().filter(x => x.First_Name.toLowerCase().includes(staff) || x.Last_Name.toLowerCase().includes(staff))
            } else {
                this.filteredStaffList = this.staffList
            }
            this.sortedStaff()
        }
    },
};
</script>

<style>
.dropdown-container {
    width: 100%;
    padding: 8px;
    border: 1px solid #cccccc;
    border-radius: 4px;
    margin-bottom: 20px;
}

.dropdown-selected {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.dropdown-arrow {
    text-align: right;
    transition: transform 0.3s ease;
}

.dropdown-arrow.open {
    transform: rotate(180deg);
}

.dropdown-options {
    margin-top: 10px;
    border: 1px solid #cccccc;
    border-top: none;
    background-color: white;
    z-index: 1000;
    color: black;
    position: fixed;
    border-radius: 4px;
    overflow: auto;
    max-height: 230px;
}

.dropdown-option {
    padding: 10px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    font-weight: bold;
    border-radius: 4px;
}

.dropdown-option:hover {
    background-color: #E9FAFF;
}

.placeholder:hover {
    background-color: transparent;
}

.name {
    flex: 1;
    text-align: left;
    font-weight: bold;
}

.status {
    width: 185px;
    margin-left: 40px;
    text-align: left;
    font-weight: bold;
}

.search{
    input{
        border: 1px solid #cccccc;
        padding: 5px;
    }
}
</style>